import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, className = "" }) => (
  <motion.div
    initial={{ opacity: 0, y: 36 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.8, delay, ease: [0.22, 1, 0.36, 1] }}
    className={className}
  >
    {children}
  </motion.div>
);

export const Chapter = ({ number, label, tone = "purple" }) => (
  <div className="mb-6 flex items-center gap-4" data-testid={`chapter-${number}`}>
    <span className="text-xs font-semibold tracking-[0.18em] text-slate-400">{number}</span>
    <span className={`h-px flex-1 ${tone === "red" ? "bg-red-200" : "bg-purple-200"}`} />
    <span
      className={`text-xs font-semibold uppercase tracking-[0.18em] ${
        tone === "red" ? "text-red-500" : "text-purple-600"
      }`}
    >
      {label}
    </span>
  </div>
);
